"use strict";
/*
 * Created on 23. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");

var FlagSet_1 = require("../../core/model/FlagSet");
/**
 * Flag related to user message.
 *
 * @author Radek Beran
 */
// tslint:disable:max-classes-per-file


var UserMessageFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(UserMessageFlag, _AdtFlag_1$AdtFlag);

  function UserMessageFlag() {
    _classCallCheck(this, UserMessageFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserMessageFlag).apply(this, arguments));
  }

  _createClass(UserMessageFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(UserMessageFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(UserMessageFlag, data);
    }
  }]);

  return UserMessageFlag;
}(AdtFlag_1.AdtFlag);

exports.UserMessageFlag = UserMessageFlag;
UserMessageFlag.TAG = '__UserMessageFlag__';
UserMessageFlag.EMPTY_SET = FlagSet_1.FlagSet.of(UserMessageFlag);